import React from 'react';
import { Link } from 'react-router-dom';
import { Brain, Code, Lightbulb, CheckCircle, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  1: Brain,
  2: Code,
  3: Lightbulb
};

const Services = () => {
  const { t, language } = useLanguage();
  
  const getPath = (path) => {
    return language === 'en' ? `/en${path}` : path;
  };

  return (
    <div className="min-h-screen pt-24 md:pt-32 pb-12 md:pb-20 px-4 md:px-6 bg-black">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-2">
            {t.services.title.split(' ')[0]} <span className="text-[#D6CE15] neon-text">{t.services.title.split(' ').slice(1).join(' ')}</span>
          </h1>
          <p className="text-base md:text-xl text-gray-400 max-w-3xl mx-auto px-4">
            {t.services.subtitle}
          </p>
        </div>

        {/* Service Categories */}
        <div className="space-y-12 md:space-y-20">
          {t.services.categories.map((category) => {
            const Icon = iconMap[category.id];
            return (
              <div key={category.id} className="max-w-5xl mx-auto">
                {/* Category Header */}
                <div className="flex items-start space-x-3 md:space-x-4 mb-6 md:mb-8">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-[#D6CE15]/10 rounded-xl flex items-center justify-center flex-shrink-0 border border-[#D6CE15]/30">
                    <Icon className="text-[#D6CE15]" size={24} />
                  </div>
                  <div>
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2 md:mb-3">
                      {category.title}
                    </h2>
                    <p className="text-sm md:text-base lg:text-lg text-gray-400 leading-relaxed">
                      {category.description}
                    </p>
                  </div>
                </div>

                {/* Offerings Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {category.offerings.map((offering, index) => (
                    <div
                      key={index}
                      className="bg-[#0a0a0a] border border-[#D6CE15]/20 rounded-xl p-6 hover:border-[#D6CE15] transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-[#D6CE15]/20"
                    >
                      <div className="flex items-start space-x-3 mb-3">
                        <CheckCircle className="text-[#D6CE15] flex-shrink-0 mt-1" size={20} />
                        <h3 className="text-lg font-semibold text-white">
                          {offering.name}
                        </h3>
                      </div>
                      <p className="text-gray-400 text-sm leading-relaxed pl-8">
                        {offering.detail}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-24 text-center">
          <div className="max-w-2xl mx-auto bg-[#0a0a0a] border border-[#D6CE15]/20 rounded-2xl p-10">
            <h3 className="text-3xl font-bold text-white mb-4">
              {t.services.cta.title}
            </h3>
            <p className="text-gray-400 mb-8">
              {t.services.cta.description}
            </p>
            <Link
              to={getPath('/contact')}
              className="inline-flex items-center space-x-2 px-8 py-4 bg-[#D6CE15] text-black rounded-lg font-semibold hover:bg-[#A4A71E] transition-all duration-200 hover:shadow-xl hover:shadow-[#D6CE15]/50 hover:-translate-y-1 group"
            >
              <span>{t.services.cta.button}</span>
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;